import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export interface BlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex?: number;
  parentElementId?: number | null;
  position: number;
  profileFieldId?: number | null;
}

/**
 * Gets element ID and elementable ID from block meta
 * Returns null for new blocks, actual IDs for existing blocks
 */
export const getElementIds = (
  block: BaseBlock,
): {
  elementId: number | null;
  elementableId: number | null;
} => {
  const meta = block.meta as BlockMeta | undefined;
  const isUUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      block.id,
    );
  const isNewBlock = isUUID || !meta;

  return {
    elementId: isNewBlock ? null : (meta?.elementId ?? null),
    elementableId: isNewBlock ? null : (meta?.elementableId ?? null),
  };
};
